import React from "react";
import { Navigate, useSearchParams } from "react-router";

const SNIPPETS_PATH = "/context/snippets";

/**
 * Build the redirect target for the legacy `/knowledge/memory` route, preserving
 * the `?id=<uuid>` query param so historical "Referenced Context" citation links
 * still open the cited snippet on the Context Engine snippets page.
 *
 * @param search The location search string (e.g. "?id=<uuid>"), with or without
 *   the leading "?".
 * @returns "/context/snippets?id=<id>" when a non-empty id is present, otherwise
 *   the bare "/context/snippets".
 */
export function buildLegacyMemoryRedirectTo(search: string): string {
  const id = new URLSearchParams(search).get("id");
  if (id) {
    return `${SNIPPETS_PATH}?id=${encodeURIComponent(id)}`;
  }
  return SNIPPETS_PATH;
}

/**
 * Redirect for the legacy `/knowledge/memory` route. Reads the current search
 * params and redirects to `/context/snippets`, preserving `?id=` so historical
 * "Referenced Context" citation links still open the cited snippet. Replaces the
 * old static `<Navigate to="/context/snippets" replace />` that discarded `?id`.
 */
export const LegacyMemoryRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  return (
    <Navigate
      to={buildLegacyMemoryRedirectTo(`?${searchParams.toString()}`)}
      replace
    />
  );
};
